import { render, staticRenderFns } from "./TransferVoucherBetweenAgentModal.vue?vue&type=template&id=1f5bc640&scoped=true&"
import script from "./TransferVoucherBetweenAgentModal.vue?vue&type=script&lang=js&"
export * from "./TransferVoucherBetweenAgentModal.vue?vue&type=script&lang=js&"
import style0 from "./TransferVoucherBetweenAgentModal.vue?vue&type=style&index=0&id=1f5bc640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5bc640",
  null
  
)

export default component.exports